import React from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Gr8piFormattedDate } from '../../../components/Gr8piFormattedDateTime';
import ArrayUtil from '../../../utils/ArrayUtil';
import { intlShape } from '../../../components/prop-types';

const messages = defineMessages({
  edit: { id: 'actions.edit', defaultMessage: 'Edit' },
});

const getTags = (survey) => {
  if (ArrayUtil.isNotEmpty(survey.tags)) {
    return survey.tags.map((tag, index) => <Badge key={survey.id + tag}>{(index ? ', ' : '') + tag}</Badge>);
  }

  return null;
};

const SurveyDetailCore = ({
  survey, toggleEdit, intl: { formatMessage },
}) => {
  if (!survey) return null;

  const spanArray = getTags(survey);

  return (
    <Panel
      header={(
        <div className="p-grid p-nogutter">
          <div className="p-col">
            {survey.self.respondent.firstName}
            {' '}
            {survey.self.respondent.lastName}
          </div>
          <div className="p-col-2 align-right">
            <Button
              type="button"
              icon="fa fa-pencil"
              className="p-button-secondary"
              onClick={() => toggleEdit('core')}
              tooltip={formatMessage(messages.edit)}
              tooltipOptions={{ position: 'bottom' }}
            />
          </div>
        </div>
      )}
    >
      <h3 className="no-margin">
        {'360: '}
        {survey.name}
      </h3>

      <div className="survey-details">
        <FormattedMessage id="jobMatch.basedOn" defaultMessage="based on" tagName="strong" />
        :
        <span>{survey.template.title}</span>
      </div>

      <div className="survey-details">
        <FormattedMessage id="attrs.created.verbose" defaultMessage="Created on" tagName="strong" />
        :
        <span>
          <Gr8piFormattedDate dateValue={survey.createdOn} />
        </span>
      </div>

      <div className="survey-details">
        <FormattedMessage id="attrs.tags" defaultMessage="Tags" tagName="strong" />
        :
        <span>{spanArray}</span>
      </div>
    </Panel>
  );
};

SurveyDetailCore.propTypes = {
  intl: intlShape.isRequired,
  survey: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleEdit: PropTypes.func.isRequired,
};

export default injectIntl(SurveyDetailCore);
